"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var PropTypes = require("prop-types");
var vdl_prefix_1 = require("../util/vdl-prefix");
var IconSize = {
    sm: {
        diameter: 26,
        strokeWidth: 3
    },
    md: {
        diameter: 40,
        strokeWidth: 4
    },
    lg: {
        diameter: 57,
        strokeWidth: 4
    },
    xl: {
        diameter: 94,
        strokeWidth: 5
    }
};
var BusyIcon = /** @class */ (function (_super) {
    __extends(BusyIcon, _super);
    function BusyIcon() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BusyIcon.prototype.render = function () {
        var size = IconSize[this.props.size];
        var radius = size.diameter / 2;
        return (React.createElement("svg", { version: "1.1", x: "0px", y: "0px", width: size.diameter, height: size.diameter, viewBox: "0 0 " + size.diameter + " " + size.diameter, className: vdl_prefix_1.vdlPrefix('busy-indicator__icon') },
            React.createElement("defs", null,
                React.createElement("clipPath", { id: "clipPath" },
                    React.createElement("rect", { x: "0", y: "0", width: radius, height: radius }))),
            React.createElement("circle", { cx: radius, cy: radius, strokeWidth: size.strokeWidth, r: radius - size.strokeWidth / 2 }),
            React.createElement("circle", { cx: radius, cy: radius, strokeWidth: size.strokeWidth, r: radius - size.strokeWidth / 2, clipPath: "url(#clipPath)" })));
    };
    BusyIcon.propTypes = {
        size: PropTypes.oneOf(['sm', 'md', 'lg', 'xl']).isRequired
    };
    return BusyIcon;
}(React.PureComponent));
exports.BusyIcon = BusyIcon;
;



//////////////////
// WEBPACK FOOTER
// ./node_modules/adp-react-components/lib/busy-indicator/busy-icon.js
// module id = 489
// module chunks = 0 1 2 3 4 5 6